import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const instrumentationKey = (window.FREIGHT_PORTAL_ENV || {}).APPLICATION_INSIGHT_KEY;

let appInsights: ApplicationInsights | null = null;

export const initAppInsight = () => {
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey,
    },
    queue: [
      () => {
        appInsights?.addTelemetryInitializer(envelope => {
          if (envelope.tags) {
            envelope.tags['ai.cloud.role'] = 'FreightPortal';
          }
        });
      },
    ],
  });

  appInsights.loadAppInsights();
};

export const trackException = (exception: Error, properties?: Record<string, unknown>) => {
  appInsights?.trackException({ exception }, properties);
};
